import { useEffect } from "react"
import { useIdleTimer } from "react-idle-timer"

import { useAppDispatch } from "@/lib/storage/hooks"
import { setIdle } from "@/lib/storage/presence-slice"
import { tick } from "@/lib/storage/ticker-thunks"

export function PresenceDetector() {
  const dispatch = useAppDispatch()

  useEffect(() => {
    const interval = setInterval(() => void dispatch(tick()), 60 * 1000)
    return () => clearInterval(interval)
  }, [dispatch])

  // Keep track of whether the user is idle or not, for use
  // when communicating status to other users. (E.g. although
  // the chat form may have a value in the input field, if
  // we're idle, we know we're not typing.)
  const onActive = () => {
    dispatch(setIdle(false))
    void dispatch(tick())
  }

  const onIdle = () => dispatch(setIdle(true))

  useIdleTimer({
    onActive,
    onIdle,
    timeout: 2 * 60 * 1000,
    throttle: 2_000,
  })

  return <></>
}
